import { STORE_FLIGHTS_IN_FLIGHTS, STORE_COUNTRIES, STORE_ALTERNATIVE_FLIGHTS } from '../actions/types';

const INITIAL_STATE = {
  inbound: null,
  outbound: null,
  // NOTE: this sessionId is used to pass along while reserving the flight only.
  sessionId: null,

  countries: null,

  // store altenative flight search results for Everest flights
  alternativeFlights: {
    inbound: null,
    outbound: null,
    sessionId: null,
  },
};

export default (state = INITIAL_STATE, action) => {
  const { inbound, outbound, sessionId, countries, alternativeFlights } = action;

  switch (action.type) {
    case STORE_FLIGHTS_IN_FLIGHTS:
      return { ...state, inbound, outbound, sessionId };

    case STORE_COUNTRIES:
      return { ...state, countries };
    
    case STORE_ALTERNATIVE_FLIGHTS:
      return { ...state, alternativeFlights };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/FlightsUiReducer.js